import userModule from "@lab/store/user.module";
import { CurrentUserStore } from "@lab/types/users";
import * as api from "@/api/user.api";
import { Dashboard } from "@lab/types/dashboard";
import router from "@/router";

const state = {
	...userModule.state
};

const getters = {
	...userModule.getters,
	dashboards: (state): Dashboard[] => state.dashboards as Dashboard[],
	fetching: (state): boolean => state.isFetching as boolean,
	errorMessage: (state): string => state.errorMessage as string,
	token: (): string => (localStorage.getItem("token") || null) as string,
	intercom: (): string =>
		(localStorage.getItem("intercom") || null) as string,
	intercomData: (state, getters) => {
		const user = state.user;

		return user
			? {
					app_id: process.env.VUE_APP_INTERCOM_APPID,
					user_id: user.id,
					user_hash: getters.intercom,
					name: `${user.firstname} ${user.lastname}`,
					email: user.email
			  }
			: null;
	},
	datalayer: (state, getters, rootState, rootGetters) => {
		const user = state.user;
		return user
			? {
					userId: user.id,
					userEmail: user.email,
					userFirstName: user.firstname,
					userLastName: user.lastname,
					userJobTitle: user.jobtitle,
					userPhone: user.phone,
					dnt: navigator.doNotTrack
			  }
			: null;
	}
};
const actions = {
	...userModule.actions,
	async setAfterHook({ commit, dispatch, getters }, { user }) {
		const dashboards = await api.dashboards(user);

		if (dashboards) {
			commit("SET_DASHBOARDS", dashboards);
		}
		if (user) {
			// Fetch some extra external data
			dispatch("chartsModule/fetch", null, { root: true });
		}
	},
	async refresh({ dispatch }) {
		const details = await api.refresh();
		dispatch("set", details);
	},
	clear({ commit }) {
		commit("RESET_USER");
	},
	logout({ dispatch }) {
		router.push({ name: "Login" });
		dispatch("clear");
	}
};
const mutations = {
	...userModule.mutations,
	SET_DASHBOARDS(state: CurrentUserStore, dashboards: Dashboard[]) {
		state.dashboards = dashboards;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
